import {
  useNavigate,
  useRouterState,
} from '@tanstack/react-router';
import {
  useEffect,
} from 'react';
import {
  useAuth,
} from 'react-oidc-context';

import {
  faro,
} from '#src/helpers/otel/faro';
import {
  PendingProgress,
} from '#components/ui/progress/PendingProgress'; // Default loading delay component
import {
  type Accountant,
} from '#src/types/auth';

export function Login(): React.ReactNode {
  // const matches = useRouterState({ select: (s) => s.matches });
  // console.debug(matches.slice(-1)[0]);
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const profile = auth.user?.profile;
      if (profile) {
        const roles: string = (profile.groups as string[]).join(',');
        const accountant: Accountant = profile.accountant as Accountant;
        faro.api.setUser({
          roles,
          email: profile.email,
          username: profile.preferred_username,
          fullName: profile.name ?? `${profile.given_name} ${profile.family_name}`,
          attributes: {
            ...accountant,
          },
        });
        console.debug('Set session User');
      } else {
        faro.api.resetUser();
      }
      console.debug(`User is authenticated`, auth.user, auth.settings, auth.events);
      // auth.activeNavigator
      if (auth.user?.expired) {

      } else {
        if (auth?.user?.url_state) {
          console.debug(
            `Redirecting to previous url state: ${auth.user?.url_state}`,
          );
          navigate({
            to: auth.user?.url_state,
          });
        } else if (auth.user) {
          navigate({
            to: '/mydigitalworkers',
          });
        } else {
          navigate({
            to: '/',
          });
        }
      }
    } else if (!auth.isLoading) {
      console.warn(`User is not authenticated`);
    }
  }, [
    auth.isAuthenticated,
    auth.isLoading,
    navigate,
  ]);

  return (
    <div
      className="flex text-center h-screen w-screen bg-1lin"
      // style={{
      //   backgroundImage: `linear-gradient(245deg, rgb(17, 10, 34, 0) 0px, rgb(19, 11, 38, 0.98) 80%, rgb(32, 10, 43, 1) 100%), url("${BGD}")`,
      // }}
    >
      <div
        className="flex h-full w-full justify-between items-start bg-[oklch(1 0 0 / 0.06)] backdrop-blur-2xl"
      >
        { auth.isLoading && (
          <PendingProgress />
        ) }
        { auth.error && !auth.isLoading && (
          <>
            <p>{ auth.error.message }</p>
          </>
        ) }
      </div>
    </div>
  );
}

export default Login;
